import React, { useEffect, useState } from 'react';
import { TrendingUp, Target } from 'lucide-react';
import { apiClient } from '../App';

const ActionLine = ({ item, testId }) => (
  <li className="text-xs sm:text-sm text-stone-800 leading-snug" data-testid={testId}>
    <span className="block font-medium">{item.name}</span>
    <span className="block text-[11px] sm:text-xs text-stone-500">{item.hits} of {item.days} day{item.days === 1 ? '' : 's'}</span>
  </li>
);

const Column = ({ icon: Icon, iconClass, label, children, testId }) => (
  <div className="flex flex-col items-center text-center min-w-0" data-testid={testId}>
    <span className={`w-12 h-12 sm:w-14 sm:h-14 rounded-full flex items-center justify-center ${iconClass}`}><Icon size={24} /></span>
    <span className="text-xs sm:text-sm font-bold uppercase tracking-wide text-stone-800 mt-1.5 mb-2 leading-tight">{label}</span>
    <div className="w-full">{children}</div>
  </div>
);

export const MonthConsistencyCard = ({ refreshKey }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    apiClient.get('/me/month-consistency').then((res) => setData(res.data)).catch(() => {});
  }, [refreshKey]);

  const active = data?.has_activity;
  return (
    <div className="bg-white border border-stone-200 rounded-xl md:rounded-2xl p-4 md:p-6" data-testid="month-consistency-card">
      <p className="text-[10px] sm:text-xs text-stone-500 uppercase tracking-wider mb-4">So far this month...</p>
      <div className="grid grid-cols-2 gap-4">
        <Column icon={TrendingUp} iconClass="bg-emerald-100 text-emerald-600" label="Crushing It!" testId="crushing-it-row">
          {active && (data.crushing.length ? (
            <ul className="space-y-2">
              {data.crushing.map((a) => <ActionLine key={a.id} item={a} testId={`crushing-${a.id}`} />)}
            </ul>
          ) : (
            <p className="text-xs text-stone-500 italic" data-testid="crushing-empty-msg">
              Hit a strategy every day and it&apos;ll show up here. You&apos;ve got this!
            </p>
          ))}
        </Column>
        <Column icon={Target} iconClass="bg-[#EFB342]/25 text-[#B8871E]" label="Your Next Opportunity" testId="next-opportunity-row">
          {active && (data.opportunities.length ? (
            <ul className="space-y-2">
              {data.opportunities.map((a) => <ActionLine key={a.id} item={a} testId={`opportunity-${a.id}`} />)}
            </ul>
          ) : (
            <p className="text-xs text-stone-500 italic">You&apos;re crushing every strategy. Amazing!</p>
          ))}
        </Column>
      </div>
    </div>
  );
};
